import { useNavigate } from "react-router-dom";
import { Zap, BadgeCheck, Timer, MessagesSquare, MousePointerClick } from "lucide-react";
import { track } from "@/lib/analytics";

const POINTS = [
  { icon: BadgeCheck, label: "100% Free" },
  { icon: Timer, label: "Fast to request" },
  { icon: MessagesSquare, label: "Compare responses" },
  { icon: MousePointerClick, label: "You choose" },
];

// Editorial closing statement — one composition, no card grid.
export const HomeWhyBrivio = () => {
  const navigate = useNavigate();
  const goRequest = () => { track("click_post_request_free", { cta: "why-get-quotes" }); navigate("/app/get-help"); };

  return (
    <section className="relative py-16 md:py-28 bg-white overflow-hidden" data-testid="home-why-brivio">
      <div className="pointer-events-none absolute -bottom-32 -right-32 w-[480px] h-[480px] rounded-full bg-[radial-gradient(circle,rgba(22,163,74,0.08),transparent_62%)]" />
      <div className="relative max-w-[1300px] mx-auto px-5 md:px-10 text-center">
        <h2 className="font-display text-[40px] md:text-[60px] font-extrabold tracking-[-0.03em] leading-[1.02] text-[var(--b2-navy)]">
          Local help.<span className="block text-[var(--b2-green)]">Made simple.</span>
        </h2>
        <div className="mt-9 flex flex-wrap justify-center gap-x-9 gap-y-4" data-testid="why-points">
          {POINTS.map((p, i) => (
            <span key={p.label} data-testid={`why-item-${i}`} className="inline-flex items-center gap-2.5 font-display font-bold text-[var(--b2-navy)] text-base md:text-lg">
              <span className="w-9 h-9 rounded-full bg-[var(--b2-green-soft)] text-[var(--b2-green)] flex items-center justify-center">
                <p.icon className="w-[18px] h-[18px]" strokeWidth={2} />
              </span>
              {p.label}
            </span>
          ))}
        </div>
        <button onClick={goRequest} data-testid="brand-card-cta"
          className="mt-11 inline-flex items-center justify-center gap-2.5 bg-[var(--b2-green)] text-white hover:bg-[var(--b2-green-hover)] rounded-[18px] px-11 py-5 font-display font-extrabold text-lg tracking-wide shadow-[0_16px_40px_rgba(22,163,74,0.35)] transition-all duration-200 hover:-translate-y-0.5 w-full sm:w-auto">
          <Zap className="w-5 h-5 fill-white" /> Get Free Local Quotes
        </button>
      </div>
    </section>
  );
};
